import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFormValues, isValid, change, reset } from 'redux-form';
import toast from '@liquidweb-dev/undercurrent/toast';
import errorActions from 'modules/error/errorActions';

import {
	actions as tldDetailsActions,
	selectors as tldDetailsSelectors,
} from 'modules/api/network/dns/domain/tldDetailsModule';
import {
	actions as createIncomingActions,
	selectors as createIncomingSelectors,
} from 'modules/api/network/dns/domain/transfer/createIncomingModule';

import { CREATE_TRANSFER_FORM_ID } from './CreateTransferForm';
import CreateTransfer from './CreateTransfer';

const mapStateToProps = (state, ownProps) => ({
	history: state.history,
	form: {
		values: getFormValues(CREATE_TRANSFER_FORM_ID)(state),
		valid: isValid(CREATE_TRANSFER_FORM_ID)(state),
	},
	created: {
		hasData: createIncomingSelectors.hasData(state),
		isLoading: createIncomingSelectors.isLoading(state),
		hasError: createIncomingSelectors.hasError(state),
	},
	tldDetails: {
		hasData: tldDetailsSelectors.hasData(state),
		isLoading: tldDetailsSelectors.isLoading(state),
		transferPrice: tldDetailsSelectors.transferPrice(state, ownProps),
	},
});

const mapDispatchToProps = (dispatch) => ({
	changeFieldValue: (field, value) =>
		dispatch(change(CREATE_TRANSFER_FORM_ID, field, value)),
	displaySnackbar: (message) => toast.info(message),
	fetchTldDetails: ({ domain }) =>
		dispatch(tldDetailsActions.fetch({ domains: domain })),
	createIncomingTransfer: (params) =>
		dispatch(createIncomingActions.fetch(params)),
	clearIncomingTransfer: () => dispatch(createIncomingActions.clear()),
	resetForm: () => dispatch(reset(CREATE_TRANSFER_FORM_ID)),
	displayError: (message) => dispatch(errorActions.pushError({ message })),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withRouter(CreateTransfer));
